import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RouteComponentProps } from 'react-router';
import { IStore } from 'reducers/index';
import { fetchExportJobCblDetails, fetchExportJobChargesDetails, fetchExportJobDetails,
         resetExportJobsDetails, sendCreateSalesOrderExport, fetchNftpBillable } from 'actions/exportJob';
import { resendLatestMessage } from 'actions/sap';
import { updateCharges, refreshAthenaRates, fetchPendingProcessMessages } from 'actions/costRevenue';
import { ErrorDialog } from 'components/error-dialog';
import { IExportJobDetail, IExportDetailsCostAndRevenue, INftpBillableResponse } from 'reducers/exportJob/models';
import API from 'constants/api';
import { IMaterialList } from 'reducers/materialMaster';
import { PageHeader } from 'components/page-header';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { calculateTotalOfField, calculateDivisionBreakdown, generateDistributionData, IDivisionBreakdown } from 'views/job-costing/utils/CostAndRevenueHelpers';
import { CostAndRevenue } from 'modules/cost-revenue/component/CostAndRevenue';
import ExportJobDetails from './ExportJobDetails';
import { DetailsTopBar } from './DetailsTopBar';
import {
    navLinksExportJob,
    voyagesCols,
    equipmentColsDocs,
} from 'constants/tableConstants';
import { withRouter } from 'react-router-dom';
import { formatValueIfNullOrUndefined, clearFormat, formatDate, isFeatureEnabled } from 'utilities/util';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { HeaderWrapper } from 'components/cost-revenue/HeaderWrapper';
import InPageDialog from '../../../../components/page-dialog';
import { Partners } from 'modules/partners/Partners';
import { SalesOrders } from 'modules/salesorders/SalesOrders';
import { HistoryLog } from 'modules/history/HistoryLog';
import * as ValidationMessages from 'constants/validationMessages';
import { FinOpsStatus, chargeStatus, costAndRevErrorMessage } from 'views/job-costing/utils/models';
import { ConfirmModal } from 'components/confirm-modal';
import { LoadingAnimation } from 'components/loading';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { fcrType, localCurrency, RECEIVING_SALES_ORDER_TAB_TITLE } from 'constants/customs';
import { fetchCostAndRevenue } from 'actions/costRevenue';
import { IResponse } from 'reducers/bookings/models';
import { fetchSalesOrderData } from 'actions/salesOrder';
import { targetFunctionality } from 'constants/targetFunctionality';
import { ModalMain } from 'damco-components';
import { ATHENA } from 'constants/messages';
import { CATEGORY } from 'constants/Levels';
import CustomErrorBox from 'components/custom-error-box/custom-error-box';
import { isNftpRoeEnabled, calculateActualTotal } from 'utilities/nftp';
import { BatchProcessingWarning } from 'components/batch-processing-warning';
import { isBatchProcessingError } from 'utilities/batchProcessing';

interface IParams {
    exportJobId: string;
}
interface IMapDispatchToProps {
    fetchExportJobDetails: (exportJobId: number) => Promise<void>;
    fetchExportJobChargesDetails: (exportJobId: number) => Promise<void>;
    updateCharges: (docId: string, docStage: number, rateAction: number) => Promise<void>;
    refreshAthenaRates: (refId: number, docId: number, docStage: number, rateAction: number) => Promise<void>;
    resendLatestMessage: (docId: string, finOpsStatus: string) => Promise<void>;
    resetExportJobsDetails: () => void;
    fetchCostAndRevenue: (type: number, valueId: any[], targetType: string) => Promise<void>;
    fetchSalesOrderData: (id: number, page?: number, pageSize?: number) => Promise<void>;
    fetchExportJobCblDetails: (exportJobId: number) => Promise<void>;
    createSalesOrderExport: (refId: number, docStage: number, rateAction: number, category: string, userId: string) => Promise<any>;
    getPendingProcessMessage: (targetId: number, targetType: string) => void;
    fetchNftpBillable: (jobId: number) => Promise<void>;
}
interface IMapStateToProps {
    exportJobDetails: IExportJobDetail;
    isLoading: boolean;
    isFetchDataError: boolean;
    detailsPendingError: string,
    update: string,
    materialMasterList: IMaterialList[];
    invoicedResponse: any;
    submitInvoiceError: boolean;
    resendResponse: string,
    resendLoading: boolean,
    resendError: string | string[],
    isResendError: boolean,
    featureToggles: IFeatureToggleModel[],
    costAndRevenueSplits: IExportDetailsCostAndRevenue[],
    isCostAndRevenueLoading: boolean,
    costAndrevenueresponse: IResponse;
    salesOrderResponseData: any;
    isCostAndRevenueLoadingError: boolean;
    exportDetailsCbl: any;
    nickname: any;
    pendingProcessingMessages: { [key: string]: any; };
    nftpBillableResponse: INftpBillableResponse | null;
    isNftpBillable: boolean | undefined;
    isNftpBillableLoading: boolean;
}
interface IExportJobCharges extends RouteComponentProps<IParams>, IMapDispatchToProps, IMapStateToProps { }
interface IState {
    activeTab: number,
    disableTab: boolean,
    hasError: boolean,
    totalRevenue: string,
    totalCost: string,
    divisionBreakdown: IDivisionBreakdown,
    showDialog: boolean,
    wasSubmitted: boolean,
    confirmDialogCancelVisible: boolean,
    confirmDialogCancelSOVisible: boolean,
    confirmDialogUpdateVisible: boolean,
    confirmDialogResendVisible: boolean,
    isSuccess: boolean,
    pendingError: any,
    status: string[] | null,
    isActionHidden: boolean,
    currentSalesOrderIndex: number,
    isShowCreateButton: boolean,
    isShowUpdateButton: boolean,
    isShowAthenaRefreshButton: boolean,
    isShowCancelButton: boolean,
    isShowResendButton: boolean;
    showPendingProcessMessage: boolean;
    showPendingProcessMessageModal: boolean;
    isNftpRoeEnabled?: boolean;
    isNftpRoeEnabledLoading?: boolean;
    actualRevenue?: string;
    actualCost?: string;
    showZeroPriceError?: boolean;
}
export class _ExportJobDetails extends React.Component<IExportJobCharges, IState> {
    constructor(props: IExportJobCharges) {
        super(props);
        this.state = this.initialState();
    }
    public componentDidMount() {
        this.props.fetchExportJobDetails(Number(this.props.match.params.exportJobId));
        this.props.fetchExportJobCblDetails(Number(this.props.match.params.exportJobId));
        this.props.fetchExportJobChargesDetails(Number(this.props.match.params.exportJobId));
        this.props.fetchCostAndRevenue(4, [Number(this.props.match.params.exportJobId)], 'origin');
        this.props.fetchSalesOrderData(Number(this.props.match.params.exportJobId), 1, 10);
        if (this.props.featureToggles && isFeatureEnabled(FEATURE_TOGGLES.SHOW_PENDING_PROCESSING_MESSAGES, this.props.featureToggles)) {
            this.props.getPendingProcessMessage(Number(this.props.match.params.exportJobId), 'Export');
        }
    }
    public componentWillUnmount() {
        this.setState(this.initialState());
        this.props.resetExportJobsDetails();
    }
    public initialState = (): IState => {
        return {
            activeTab: 0,
            isSuccess: false,
            disableTab: false,
            showDialog: false,
            wasSubmitted: false,
            confirmDialogCancelVisible: false,
            confirmDialogCancelSOVisible: false,
            confirmDialogUpdateVisible: false,
            confirmDialogResendVisible: false,
            totalRevenue: '0',
            totalCost: '0',
            divisionBreakdown: { rows: [], total: { division: 'Total', revenue: 0, cost: 0, profit: 0 } },
            pendingError: '',
            status: null,
            hasError: false,
            isActionHidden: false,
            currentSalesOrderIndex: 0,
            isShowCreateButton: false,
            isShowUpdateButton: false,
            isShowAthenaRefreshButton: false,
            isShowCancelButton: false,
            isShowResendButton: false,
            showPendingProcessMessage: false,
            showPendingProcessMessageModal: false,
            isNftpRoeEnabled: false,
            isNftpRoeEnabledLoading: true,
            actualRevenue: '0',
            actualCost: '0',
            showZeroPriceError: false,
        };
    };
    public async componentDidUpdate(props: IExportJobCharges, prevState: any) {
        if (props.pendingProcessingMessages !== this.props.pendingProcessingMessages) {
            this.setState({ showPendingProcessMessage: true });
        }
        const salesOrdersChanged = props.salesOrderResponseData.data !== this.props.salesOrderResponseData.data;
        const exportJobChanged = props.exportJobDetails !== this.props.exportJobDetails;
        const salesOrderIndexChanged = this.state.currentSalesOrderIndex !== prevState.currentSalesOrderIndex;
        const hasSalesOrders = this.props.salesOrderResponseData.data.length > 0;
        if (exportJobChanged) {
            if (this.props.match.params.exportJobId && isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_SALESORDER_REQ_EXPORT, this.props.featureToggles)) {
                await this.props.fetchNftpBillable(Number(this.props.match.params.exportJobId));
            }
            this.setState({ isNftpRoeEnabled: isNftpRoeEnabled(this.props.isNftpBillable ?? false, this.props.featureToggles) });
            this.setState({ isNftpRoeEnabledLoading: false});
            this.getActualTotal();
            this.validateZeroPricedItems();
        }
        if (salesOrderIndexChanged || salesOrdersChanged || exportJobChanged) {
            if (hasSalesOrders) {
                this.checkShowCreate();
                this.checkShowUpdate();
                this.checkcancel(true);
                this.checkShowResend();
            }
            this.checkShowAthenaRefreshButton();
        }
        if (this.props.invoicedResponse !== props.invoicedResponse) {
            if (!this.props.submitInvoiceError && this.props.invoicedResponse.length > 0) {
                let resp = '';
                this.props.invoicedResponse.forEach((entry: any) => {
                    resp += `${entry.finOpsInvoiceNumber}, sent to ${entry.email ? entry.email : entry.printerName}. `;
                });
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: `Successfully issued invoice: ${resp}`
                }, () => {
                    this.props.fetchExportJobDetails(Number(this.props.match.params.exportJobId));
                    this.props.fetchExportJobChargesDetails(Number(this.props.match.params.exportJobId));
                });
            } else {
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: this.props.invoicedResponse ? this.props.invoicedResponse : 'Failed to create an Invoice'
                });
            }
        }
        if (this.props.resendResponse !== props.resendResponse) {
            if (!this.props.isResendError && this.props.resendResponse) {
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: `Successfully resent message to SAP`
                });
            } else if (this.props.isResendError && this.props.resendError) {
                const rawResendError = Array.isArray(this.props.resendError)
                    ? this.props.resendError.join('\n')
                    : this.props.resendError;
                const resendErrorText = rawResendError ? rawResendError.replace(/\|/g, '\n') : '';
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: resendErrorText || 'Failed to resend message to SAP'
                });
            }
        }
        if (props.isFetchDataError !== this.props.isFetchDataError &&
            this.props.isFetchDataError === true && this.props.detailsPendingError) {
            let checkText: string | string[] = props.detailsPendingError;
            if ((Array.isArray(this.props.detailsPendingError) &&
                this.props.detailsPendingError.length === 0) ||
                this.props.detailsPendingError === '') {
                checkText = 'Server Error. Try again later.';
            }
            this.setState({ isSuccess: false, showDialog: true, pendingError: checkText.toString() });
        }
        if (this.props.exportJobDetails && this.props.exportJobDetails.rateErrorMessage !== props.exportJobDetails.rateErrorMessage) {
            const handleError = (error: string): boolean => {
                if (error) {
                    if (isBatchProcessingError(error)) {
                        // Batch-processing errors are surfaced via the dedicated
                        // wait banner; close any stale generic error dialog left
                        // over from a previous non-batch error message.
                        this.setState({ showDialog: false, pendingError: '' });
                    } else {
                        this.setState({ isSuccess: false, showDialog: true, pendingError: error.toString().replace(/\|/g, '\n') });
                    }
                    return true;
                }
                return false;
            };
            const hasError: boolean = this.props.exportJobDetails && this.props.exportJobDetails.rateErrorMessage ? handleError(this.props.exportJobDetails.rateErrorMessage) : false;
            this.setState({
                hasError,
                isSuccess: !hasError
            });
        }
        if (this.props.update && this.props.update !== props.update) {
            if (this.props.isCostAndRevenueLoadingError) {
                this.setState({ isSuccess: false, showDialog: true, pendingError: this.props.update });
            } else {
                this.setState({ isSuccess: true, showDialog: true, pendingError: this.props.update });
                setTimeout(() => {
                    this.props.fetchSalesOrderData(Number(this.props.match.params.exportJobId), 1, 10);
                    this.props.fetchExportJobDetails(Number(this.props.match.params.exportJobId));
                    this.props.fetchExportJobChargesDetails(Number(this.props.match.params.exportJobId));
                }, this.props.isNftpBillable ? 500 : 2000);
            }
        }
        if (this.props.exportJobDetails && this.props.exportJobDetails.finOpsStatus !== props.exportJobDetails.finOpsStatus) {
            const status: string[] = this.props.exportJobDetails && this.props.exportJobDetails.finOpsStatus ? [this.props.exportJobDetails.finOpsStatus] : [];
            this.setState({
                status
            });
        }
    }

    public validateZeroPricedItems = () => {
        const rateDetailsList = this.props.costAndrevenueresponse.result[0]?.essoRateDetailsModels || [];
        const zeroPricedItems = rateDetailsList.filter((item: any) => item.rate === 0 && item.status === chargeStatus.linkedSalesOrder);
        if (zeroPricedItems.length > 0) {
            this.setState({showZeroPriceError: true });
        }
    };

    public getActualTotal = () => {
        const rateDetailsList = this.props.costAndrevenueresponse.result[0]?.essoRateDetailsModels || [];
        const actualRevenue = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.REVENUE);
        const actualCost = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.COST);
        this.setState({ actualRevenue, actualCost }) ;
    };
    public checkShowInvoices = (): boolean => {
        const isCBLDraftStatus = this.isCBLDraftStatus();
        const resp = Boolean((this.props.exportJobDetails.finOpsStatus) &&
            (this.props.exportJobDetails.finOpsStatus === FinOpsStatus.partialInvoiced ||
                this.props.exportJobDetails.finOpsStatus === FinOpsStatus.partialSettled ||
                this.props.exportJobDetails.finOpsStatus === FinOpsStatus.salesOrderCreated ||
                this.props.exportJobDetails.finOpsStatus === FinOpsStatus.salesOrderUpdated)) &&
            Boolean(this.props.exportJobDetails.opsStatus) &&
            Boolean(this.props.exportJobDetails.opsStatus !== 'DraftApprovedRejected') &&
            Boolean(this.props.exportJobDetails.salesOrderNumber) &&
            Boolean(this.props.exportJobDetails.consigneeFactCode) &&
            !Boolean(this.props.exportJobDetails.rateErrorMessage) &&
            !isCBLDraftStatus;
        return resp;
    };

    public checkShowCreate = () => {
        const finSalesOrderStatusByIndex = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].finOpsStatus;
        const status = (Boolean(finSalesOrderStatusByIndex) && !this.state.wasSubmitted &&
            finSalesOrderStatusByIndex === FinOpsStatus.salesOrderCreated) &&
            !Boolean(this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].salesOrderNumber) &&
            Boolean(this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].rateErrorMessage);
        this.setState({ isShowCreateButton: status });
    };
    public isReceivingFCR = (): boolean =>
        this.props.exportJobDetails.businessSubCategory === fcrType.RECEIVING;

    // Receiving (RFREV) jobs keep the Sales Order tab and its action buttons even on the
    // NFTP-billable route, where both are otherwise hidden. Off by default: with
    // FINOPS_RECEIVING_FCR disabled the page behaves exactly as it did before.
    public showReceivingSalesOrderTab = (): boolean =>
        isFeatureEnabled(FEATURE_TOGGLES.FINOPS_RECEIVING_FCR, this.props.featureToggles)
        && Boolean(this.props.isNftpBillable)
        && this.isReceivingFCR();

    // A receiving (RFREV) job carries several sales orders over one set of charge items, so the
    // job-wide "any charge item exists" check passes even when the selected sales order has none
    // of its own. Updating such a sales order makes SAP acknowledge it with empty ChargeDetails,
    // which FinOps then rejects and the sales order is left at "Sales Order Update Requested".
    // Off by default: with FINOPS_RECEIVING_FCR disabled the job-wide check is used as before.
    public useReceivingSalesOrderValidation = (): boolean =>
        isFeatureEnabled(FEATURE_TOGGLES.FINOPS_RECEIVING_FCR, this.props.featureToggles)
        && this.isReceivingFCR();

    public getCurrentSalesOrderNumber = (): string => {
        const salesOrders = this.props.salesOrderResponseData?.data;
        if (!salesOrders || salesOrders.length === 0) {
            return '';
        }
        return salesOrders[this.state.currentSalesOrderIndex]?.salesOrderNumber || '';
    };

    public hasChargeItemsForCurrentSalesOrder = (): boolean => {
        const salesOrderNumber = this.getCurrentSalesOrderNumber();
        if (!salesOrderNumber) {
            return false;
        }
        const chargeItems = this.props.costAndrevenueresponse?.result?.[0]?.essoRateDetailsModels || [];
        return chargeItems.some((item: any) => item.salesOrderNumber === salesOrderNumber);
    };

    public checkShowUpdate = () => {
        const errorRegex = /Sales organization is changed from (BRE|Extra Document Configuration), Kindly cancel and refresh the rates, Existing Sales Org/;
        const isSalesOrgChanged = errorRegex.test(this.state.pendingError);
        const vatPartnerErrorRegex = /vat partner determination has failed/i;
        const isVatPartnerError = vatPartnerErrorRegex.test(this.state.pendingError.toLowerCase());
        const isReceivingFCR = this.isReceivingFCR();
        const finSalesOrderStatusByIndex = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].finOpsStatus;
        const finSalesOrderJobCloseStatusByIndex = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].isClosed;
        const finSalesOrderStatusByIndexTriggeredByDocumentType = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].triggeredByDocumentType;
        const finSalesOrderStatusByIndexTriggeredByDocumentNo = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].triggeredByDocumentNumberforCBL;
        const isInvoiceInFinopsCreated = this.props.exportJobDetails.finOpsStatus.toLocaleLowerCase() === FinOpsStatus.invoiceInFinopsCreatedLowerCase;
        let isCBLDraftStatus;
        if (isReceivingFCR) {
            if (finSalesOrderStatusByIndexTriggeredByDocumentType === 'CBL') {
                const checkCBLNn = this.props.exportDetailsCbl.filter((item: any) => item.number === finSalesOrderStatusByIndexTriggeredByDocumentNo);
                if (checkCBLNn.length && checkCBLNn[0].opsStatus === 'Draft') {
                    isCBLDraftStatus = true;
                }
            } else if (finSalesOrderStatusByIndexTriggeredByDocumentType === 'FCR') {
                isCBLDraftStatus = this.isCBLDraftStatus();
            }
        } else {
            isCBLDraftStatus = this.isCBLDraftStatus();
        }
        const status: boolean = Boolean(finSalesOrderStatusByIndex) && !this.state.wasSubmitted &&
            Boolean(this.props.exportJobDetails.salesOrderNumber) &&
            finSalesOrderStatusByIndex !== FinOpsStatus.open &&
            !isInvoiceInFinopsCreated &&
            finSalesOrderStatusByIndex !== FinOpsStatus.rejected &&
            !finSalesOrderStatusByIndex.includes('Requested') &&
            finSalesOrderJobCloseStatusByIndex !== 'CLOSED' &&
            !isCBLDraftStatus && !isSalesOrgChanged && !isVatPartnerError;
        this.setState({ isShowUpdateButton: status });
    };
    public checkShowAthenaRefreshButton = () => {
        const isInvoiceInFinopsCreated = this.props.exportJobDetails.finOpsStatus.toLocaleLowerCase() === FinOpsStatus.invoiceInFinopsCreatedLowerCase;
        const salesOrdersLength = this.props.salesOrderResponseData?.data?.length || 0;
        const itemsIncludeAthena = this.props.exportJobDetails.pricingSource === 2 || this.props.exportJobDetails.pricingSource === ATHENA;
        const finSalesOrderStatusByIndex = this.props.salesOrderResponseData?.data[this.state.currentSalesOrderIndex]?.finOpsStatus;
        const isClosed = this.props.salesOrderResponseData?.data[this.state.currentSalesOrderIndex]?.isClosed;
        // Full Settled still allows a rate refresh; only in-flight (Requested) statuses hide it.
        const isRequested = finSalesOrderStatusByIndex ? finSalesOrderStatusByIndex.includes('Requested') : false;
        if (salesOrdersLength) {
            this.setState({ isShowAthenaRefreshButton: itemsIncludeAthena === true && !isInvoiceInFinopsCreated && !isRequested && isClosed !== 'CLOSED' });
        } else {
            this.setState({ isShowAthenaRefreshButton: itemsIncludeAthena === true && !isInvoiceInFinopsCreated });
        }
    };
    // Profitability breakdown is shown only when the export MCI charge feature is on
    // and both SCM and MCI division charges are present.
    public getProfitabilityBreakdown = (): IDivisionBreakdown | undefined => {
        const isMciChargeEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXPORT_MCI_CHARGE_ENABLED, this.props.featureToggles);
        const divisions = this.state.divisionBreakdown.rows.map((row) => row.division);
        const hasScmAndMci = divisions.includes('SCM') && divisions.includes('MCI');
        return isMciChargeEnabled && hasScmAndMci ? this.state.divisionBreakdown : undefined;
    };
    public checkcancel = (isCancel: boolean = false) => {
        const isInvoiceInFinopsCreated = this.props.exportJobDetails.finOpsStatus.toLocaleLowerCase() === FinOpsStatus.invoiceInFinopsCreatedLowerCase;
        const finSalesOrderJobCloseStatusByIndex = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].isClosed;
        const isReceivingFCR = this.isReceivingFCR();
        const finSalesOrderStatusByIndex = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].finOpsStatus;
        const finSalesOrderStatusByIndexTriggeredByDocumentType = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].triggeredByDocumentType;
        const finSalesOrderStatusByIndexTriggeredByDocumentNo = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].triggeredByDocumentNumberforCBL;
        let isCBLDraftStatus;
        if (isReceivingFCR) {
            if (finSalesOrderStatusByIndexTriggeredByDocumentType === 'CBL') {
                const checkCBLNn = this.props.exportDetailsCbl.filter((item: any) => item.number === finSalesOrderStatusByIndexTriggeredByDocumentNo);
                if (checkCBLNn.length && checkCBLNn[0].opsStatus === 'Draft') {
                    isCBLDraftStatus = true;
                }
            } else if (finSalesOrderStatusByIndexTriggeredByDocumentType === 'FCR') {
                isCBLDraftStatus = this.isCBLDraftStatus();
            }
        } else {
            isCBLDraftStatus = this.isCBLDraftStatus();
        }
        let status: boolean = Boolean(finSalesOrderStatusByIndex) &&
            Boolean(this.props.exportJobDetails.salesOrderNumber) &&
            finSalesOrderStatusByIndex !== FinOpsStatus.open &&
            finSalesOrderStatusByIndex !== FinOpsStatus.rejected &&
            !finSalesOrderStatusByIndex.includes('Requested') &&
            finSalesOrderJobCloseStatusByIndex !== 'CLOSED' &&
            !isCBLDraftStatus;
        if (isCancel) {
            status = status &&
                !isInvoiceInFinopsCreated &&
                finSalesOrderStatusByIndex !== FinOpsStatus.partialInvoiced &&
                finSalesOrderStatusByIndex !== FinOpsStatus.fullInvoiced &&
                finSalesOrderStatusByIndex !== FinOpsStatus.partialSettled &&
                finSalesOrderStatusByIndex !== FinOpsStatus.fullSettled;
        }
        this.setState({ isShowCancelButton: status });
    };
    public checkShowResend = () => {
        const isInvoiceInFinopsCreated = this.props.exportJobDetails.finOpsStatus.toLocaleLowerCase() === FinOpsStatus.invoiceInFinopsCreatedLowerCase;
        const finSalesOrderStatusByIndex = this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].finOpsStatus;
        const status = Boolean(finSalesOrderStatusByIndex) &&
            !isInvoiceInFinopsCreated &&
            (finSalesOrderStatusByIndex === FinOpsStatus.rateRequested ||
                finSalesOrderStatusByIndex === FinOpsStatus.salesOrderRequested ||
                finSalesOrderStatusByIndex === FinOpsStatus.salesOrderUpdateRequested ||
                finSalesOrderStatusByIndex === FinOpsStatus.salesOrderCancelRequested);
        this.setState({ isShowResendButton: status });
    };

    public checkShowCreateSalesOrder = () => {
        const { featureToggles, exportJobDetails } = this.props;
        const isSalesOrderRequested = exportJobDetails.finOpsStatus === FinOpsStatus.salesOrderRequested;
        const hasRateErrorMessage = !!exportJobDetails.rateErrorMessage;

        return isFeatureEnabled(FEATURE_TOGGLES.FINOPS_FINANCE_OUTBOUND_REQUESTS, featureToggles) &&
            isSalesOrderRequested &&
            hasRateErrorMessage;
    };

    public onSalesOrderModalRadioButtonChange = (index: number) => {
        this.setState({
            currentSalesOrderIndex: index
        });
    };
    public isCBLDraftStatus = () => {
        return this.props.exportDetailsCbl.some((obj: any) => obj.opsStatus === 'Draft');
    };
    public checkCancelDialog = (status: string) => {
        const resultDataLength = this.props.costAndrevenueresponse.result;
        const getChargeItemSOStatusRev: any[] = resultDataLength.length > 0 && resultDataLength[0].hasOwnProperty('essoRateDetailsModels') && this.props.costAndrevenueresponse.result[0].essoRateDetailsModels.filter((item: any) => item.itemCategory === CostColumnsData.TYPES.REVENUE).filter((item: any) => {
            return item.status === chargeStatus.linkedFinalInvoice || item.status === chargeStatus.linkedPartialSupplierInvoice || item.status === chargeStatus.linkedSupplierInvoice;
        });
        const getChargeItemSOStatusCost: any[] = resultDataLength.length > 0 && resultDataLength[0].hasOwnProperty('essoRateDetailsModels') && this.props.costAndrevenueresponse.result[0].essoRateDetailsModels.filter((item: any) => item.itemCategory === CostColumnsData.TYPES.COST).filter((item: any) => {
            return item.status === chargeStatus.linkedPartialSupplierInvoice || item.status === chargeStatus.linkedSupplierInvoice;
        });
        if (getChargeItemSOStatusCost.length > 0) {
            this.setState({
                confirmDialogCancelSOVisible: true,
                confirmDialogCancelVisible: false
            });
        } else if (getChargeItemSOStatusRev.length > 0) {
            this.setState({
                confirmDialogCancelSOVisible: true,
                confirmDialogCancelVisible: false
            });
        } else {
            this.setState({
                confirmDialogCancelVisible: true,
                confirmDialogCancelSOVisible: false
            });
        }
    };

    public checkJobCloseStatus = () => {
        const jobStatus = this.props.salesOrderResponseData.data.some((item: any) => item.isClosed === 'CLOSED');
        return jobStatus;
    };

    public handleSendCreateSalesOrder = async (exportJobId: string) => {
        const { createSalesOrderExport, nickname } = this.props;
        await createSalesOrderExport(Number(exportJobId), 2, 1, CATEGORY.ESSO, nickname.employeeId)
            .then((data) => {
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: data
                });
            })
            .catch((error) => {
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: error.response.data ? error.response.data : 'Failed to Create Sales Order'
                });
            });
    };

    public getActionButtons = () => {
        if (this.state.isActionHidden) {
            return null;
        }

        const isResendMessageFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.RESEND_LAST_MESSAGE, this.props.featureToggles);
        const showButtonGroup = this.state.isShowCreateButton || this.state.isShowUpdateButton ||
            this.state.isShowAthenaRefreshButton || this.state.isShowCancelButton ||
            (this.state.isShowResendButton && isResendMessageFeatureEnabled);

        if (!showButtonGroup) {
            return null;
        }

        const salesOrderNumber = this.props.salesOrderResponseData.data &&
            this.props.salesOrderResponseData.data.length > 0 &&
            this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].id;

        return (
            <div className="grid-toolbar context-ribbon-extra" style={{ marginBottom: '8px' }}>
                <div className="button-group context-left context-buttons" role="group" aria-label="Action buttons">
                    {this.state.isShowUpdateButton &&
                        <button type="button" onClick={() => this.setState({ confirmDialogUpdateVisible: true })} className="button button-context">Update Sales Order</button>}
                    {this.state.isShowCancelButton &&
                        <button type="button" onClick={() => this.checkCancelDialog(this.props.salesOrderResponseData.data && this.props.salesOrderResponseData.data.length > 0 && this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].triggeredByDocumentType)} className="button button-context">Cancel Sales Order</button>}
                    {this.state.isShowAthenaRefreshButton &&
                        <button type="button" onClick={() => this.props.refreshAthenaRates(salesOrderNumber, this.props.exportJobDetails.documentId, 2, 12)} className="button button-context">Refresh Athena Rate</button>}
                    {this.state.isShowCreateButton &&
                        <button type="button" onClick={() => { this.props.updateCharges(salesOrderNumber, 2, 1); this.setState({ wasSubmitted: true }); }} className="button button-context">Create Sales Order (Resend)</button>}
                    {this.state.isShowResendButton && isResendMessageFeatureEnabled &&
                        <button type="button" onClick={() => this.setState({ confirmDialogResendVisible: true })} className="button button-context">Resend Latest Message</button>}
                    {this.checkShowCreateSalesOrder() &&
                        <button type="button" onClick={() => this.handleSendCreateSalesOrder(this.props.match.params.exportJobId)} className="button button-context">Send Create Sales Order</button>}
                </div>
            </div>
        );
    };

    public renderTabChildren = (isExtraDocumentFeatureEnabled: boolean, enableBlockedType: boolean) => {
        const tabChildren: React.ReactNode[] = [];

        // Tab 0: Charges (always present)
        tabChildren.push(
            <div key="charges" className="exportjob-charges">
                {!this.props.isNftpBillableLoading && this.props.isNftpBillable
                    && !this.showReceivingSalesOrderTab() && this.getActionButtons()}
                {!this.props.isNftpBillableLoading && !this.state.isNftpRoeEnabledLoading && !this.props.isCostAndRevenueLoading 
                && this.props.exportJobDetails.documentId && this.props.costAndrevenueresponse.result.length > 0 
                && <CostAndRevenue
                    targetType="origin"
                    toggleTabs={(b: boolean) => this.setState({ disableTab: b })}
                    fStatus={[this.props.exportJobDetails.finOpsStatus]}
                    targetId={targetFunctionality.FCR_ExportJob}
                    showInvoices={this.checkShowInvoices()}
                    invoicesData={{
                        consignee: this.props.exportJobDetails.consigneeFactCode,
                        companyCode: this.props.exportJobDetails.companyCode,
                        billingCurrency: this.props.exportJobDetails.salesDocumentCurrency,
                        salesArea: this.props.exportJobDetails.salesArea,
                        fcrNumber: this.props.exportJobDetails.originalDocumentNumber,
                        fcrId: this.props.exportJobDetails.documentId,
                        finNumber: this.props.exportJobDetails.finNumber,
                    }}
                    costAndrevenueresponse={this.props.costAndrevenueresponse}
                    partyData={{
                        country: this.props.exportJobDetails.issuerCountryCode,
                        company: this.props.exportJobDetails.companyCode,
                        purchase: this.props.exportJobDetails.purchaseOrganisation
                    }}
                    getCurrentPageMode={(mode) => this.setState({ isActionHidden: (mode === 'edit' || mode === 'add') ? true : false })}
                    distributionData={generateDistributionData({ costAndRevenueSplits: this.props.costAndRevenueSplits })}
                    readOnly={false}
                    splitCols={CostColumnsData.getCostFCRSubCols()}
                    type={this.props.exportJobDetails.type}
                    businessSubCategory={this.props.exportJobDetails.businessSubCategory}
                    docId={Number(this.props.exportJobDetails.documentId)}
                    costAndRevenueId={Number(this.props.exportJobDetails.documentId)}
                    navigateTo={(url: string) => this.props.history.push(url)}
                    eventCallback={() => this.setState({ showDialog: false, pendingError: '' })}
                    isJobClosed={this.checkJobCloseStatus()}
                    isNftpBillable={this.props.isNftpBillable}
                    isNftpRoeEnabled={this.state.isNftpRoeEnabled}
                    outputCostRev={(cost: any[], revenue: any[]) => {
                        this.setState({ totalCost: clearFormat(calculateTotalOfField(cost, localCurrency.totalLocalCurrency)) });
                        this.setState({ totalRevenue: clearFormat(calculateTotalOfField(revenue, localCurrency.totalLocalCurrency)) });
                        this.setState({ divisionBreakdown: calculateDivisionBreakdown(cost, revenue, localCurrency.totalLocalCurrency) });
                    }}
                    isSourceAthena={this.props.exportJobDetails?.pricingSource === 2 || this.props.exportJobDetails?.pricingSource === ATHENA} />}
            </div>
        );

        // Tab: Sales Orders (conditionally present)
        const showReceivingSalesOrderTab = this.showReceivingSalesOrderTab();
        const salesOrderIndex = tabChildren.length;
        if (!this.props.isNftpBillableLoading && (!this.props.isNftpBillable || showReceivingSalesOrderTab)) {
            tabChildren.push(
                this.state.activeTab === salesOrderIndex && (<div key="salesOrders">
                    {this.getActionButtons()}
                    <SalesOrders
                        key="salesOrders"
                        index={this.state.currentSalesOrderIndex}
                        setCurrentIndex={this.onSalesOrderModalRadioButtonChange}
                        number={this.props.salesOrderResponseData.data && this.props.salesOrderResponseData.data.length > 0 && this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].id}
                        isModalOpen={false}
                        targetId={this.props.exportJobDetails.documentId}
                        showCreate={this.state.isShowCreateButton}
                        showUpdate={this.state.isShowUpdateButton}
                        showAthenaRefreshButton={this.state.isShowAthenaRefreshButton}
                        showCancel={this.state.isShowCancelButton}
                        showResend={this.state.isShowResendButton}
                        showCreateSalesOrder={this.checkShowCreateSalesOrder()}
                        onUpdate={(id: any) => { this.setState({ confirmDialogUpdateVisible: true }); }}
                        onAthenaRefresh={(id: any) => { this.props.refreshAthenaRates(id, this.props.exportJobDetails.documentId, 2, 12); }}
                        onCancel={(salesOrderNumber: any) => { this.checkCancelDialog(this.props.salesOrderResponseData.data && this.props.salesOrderResponseData.data.length > 0 && this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].triggeredByDocumentType); }}
                        onCreate={(id: any) => { this.props.updateCharges(id, 2, 1); this.setState({ wasSubmitted: true }); }}
                        onResend={(id: any) => { this.setState({ confirmDialogResendVisible: true }); }}
                        onSendCreateSalesOrder={() => { this.handleSendCreateSalesOrder(this.props.match.params.exportJobId); }}
                        isResendMessageFeatureEnabled={isFeatureEnabled(FEATURE_TOGGLES.RESEND_LAST_MESSAGE, this.props.featureToggles)}
                        hideSalesOrderNumber={showReceivingSalesOrderTab}
                    />
                </div>)
            );
        }

        // Tab: Export Job details (always present)
        tabChildren.push(
            <ExportJobDetails
                key="exportJobDetails"
                // TODO: Remove unwanted props,all can be passed through exportJobDetails.
                organisation={[
                    { label: 'Company Code', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.companyCode) },
                    { label: 'Sales Area', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.salesArea) },
                    { label: 'Origin Office', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.originOffice) },
                    { label: 'Destination Office', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.destinationOffice) },
                    { label: 'Sales Document Currency', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.salesDocumentCurrency) },
                    { label: 'Sales Document Net Value', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.salesDocumentNetValue) },
                    { label: 'Sales Document Type', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.salesDocumentType) },
                    { label: 'Create Date', value: formatDate(this.props.exportJobDetails.createDate, 'YYYY-MM-DD HH:mm:ss') }
                ]}
                locations={[
                    { label: 'Place of receipt code', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.placeOfReceiptCode) },
                    { label: 'Port of loading code', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.portOfLoadingCode) },
                    { label: 'Port of discharge code', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.portOfDischargeCode) },
                    { label: 'Place of delivery code', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.placeOfDeliveryCode) },
                    { label: 'Place of receipt name', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.placeOfReceiptName) },
                    { label: 'Port of loading name', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.portOfLoadingName) },
                    { label: 'Port of discharge name', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.portOfDischargeName) },
                    { label: 'Place of delivery name', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.placeOfDeliveryName) },
                ]}
                jobIdDetails={[
                    { label: 'Export', value: formatValueIfNullOrUndefined(this.props.exportJobDetails.finNumber) },
                    { label: 'Import', value: formatValueIfNullOrUndefined('') }
                ]}
                link={(url: string) => { this.props.history.push(url); }}
                equipments={{ data: this.props.exportJobDetails.equipments, cols: equipmentColsDocs, name: 'fcr-billingDocuments-' }}
                voyages={{ data: this.props.exportJobDetails.voyages, cols: voyagesCols, name: 'fcr-voyages-' }}
                isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                exportJobId={this.props.exportJobDetails.documentId}
                exportJobDetails={this.props.exportJobDetails}
            />
        );

        // Partners
        const partnersIndex = tabChildren.length;

        tabChildren.push(
            this.state.activeTab === partnersIndex && (
                <Partners
                    key="partners"
                    isVisible={true}
                    target={4}
                    targetId={this.props.exportJobDetails.documentId}
                />
            )
        );

        // History
        const historyIndex = tabChildren.length;

        tabChildren.push(
            this.state.activeTab === historyIndex && !this.props.isNftpBillableLoading && (
                <HistoryLog
                    key="history"
                    shipmentId={this.props.exportJobDetails.documentId.toString()}
                    shipmentType={6}
                    isSourceAthena={
                        this.props.exportJobDetails?.pricingSource === 2 ||
                        this.props.exportJobDetails?.pricingSource === ATHENA
                    }
                    enableBlockedType={enableBlockedType}
                    isNftpBillable={this.props.isNftpBillable}
                />
            )
        );

        return tabChildren;
    };

    public render() {
        const isReceivingFCR = this.isReceivingFCR();
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const enableBlockedType = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION, this.props.featureToggles);
        const documentLink = ['FCR', 'HBL', 'HSWB'].includes(this.props.exportJobDetails.primaryDocumentType) ?
            '/job-costing/documents/' : '/job-costing/cbls/';
        const showReceivingSalesOrderTab = this.showReceivingSalesOrderTab();
        const exportJobNavLinks = navLinksExportJob(
            Boolean(this.props.isNftpBillable) && !showReceivingSalesOrderTab,
            showReceivingSalesOrderTab ? RECEIVING_SALES_ORDER_TAB_TITLE : 'Sales Orders',
        );
        let isCostAndrevenueresponse;
        const resultDataLength = this.props.costAndrevenueresponse.result;
        if (resultDataLength.length > 0) {
            if (resultDataLength[0].hasOwnProperty('essoRateDetailsModels')) {
                isCostAndrevenueresponse = resultDataLength[0].essoRateDetailsModels.length > 0;
            } else if (resultDataLength[0].hasOwnProperty('issoChargeLines')) {
                isCostAndrevenueresponse = resultDataLength[0].issoChargeLines.length > 0;
            } else {
                isCostAndrevenueresponse = false;
            }
        }
        const hasChargeItemsForUpdate = this.useReceivingSalesOrderValidation()
            ? this.hasChargeItemsForCurrentSalesOrder()
            : isCostAndrevenueresponse;
        return (
            <React.Fragment>
                {this.props.isLoading && <LoadingAnimation />}
                <ErrorDialog endpoint={API.ExportJob.ExportJobDetail} />
                {this.props.exportJobDetails && this.props.exportJobDetails.documentNumber && <PageHeader backButton={true}
                    displayConfirm={this.state.disableTab}
                    confirmMessage={this.state.disableTab ? ValidationMessages.CostAndRevenue.Alert_Page_Exit : ''}
                    id="exportJobs-details">Export Job: {this.props.exportJobDetails.finNumber}
                    {isReceivingFCR && <span> (Receiving CFS)</span>}
                </PageHeader>}
                {/* Pending Processing Messages */}
                {this.state.showPendingProcessMessage && this.props.pendingProcessingMessages?.messages?.length > 0 &&
                    <CustomErrorBox
                        messages={this.props.pendingProcessingMessages.messages}
                        onViewAllMessages={() => this.setState({ showPendingProcessMessageModal: true })}
                        onClose={() => this.setState({ showPendingProcessMessage: false })}
                    />
                }
                {isBatchProcessingError(this.props.exportJobDetails.rateErrorMessage) &&
                    <div className={'padding-bottom-large padding-left-large padding-right-large'}>
                        <BatchProcessingWarning
                            rateErrorMessage={this.props.exportJobDetails.rateErrorMessage}
                            lastSORequestSentAt={this.props.exportJobDetails.lastSORequestSentAt}
                        />
                    </div>}
                {this.state.showZeroPriceError && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showZeroPriceError}
                    type="error"
                    message={costAndRevErrorMessage.zeroPriceError}
                    isSalesOrderMsg={true}
                    closeMethod={() => this.setState({ showZeroPriceError: false })} /></div>}
                {this.state.showDialog && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showDialog}
                    type={this.state.isSuccess ? 'success' : 'error'}
                    message={this.state.pendingError}
                    isSalesOrderMsg={this.props.isCostAndRevenueLoadingError}
                    closeMethod={() => this.setState({ showDialog: false, isSuccess: false })} /></div>}
                {this.state.confirmDialogCancelVisible && <ConfirmModal
                    title="Cancel Sales Order"
                    visible={this.state.confirmDialogCancelVisible}
                    onConfirm={() => {
                        this.setState({ confirmDialogCancelVisible: false, showDialog: false, pendingError: '' });
                        this.props.updateCharges(this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].id.toString(), 2, 3);
                    }}
                    closeModal={() => { this.setState({ confirmDialogCancelVisible: false }); }}>
                    {ValidationMessages.General.Alert_Cancel_Page}

                </ConfirmModal>}

                {this.state.showPendingProcessMessageModal &&
                    <div className="errorModal">
                        <ModalMain
                            modal={this.state.showPendingProcessMessageModal}
                            title="View All Pending Process Messages"
                            hideMethod={() => { this.setState({ showPendingProcessMessageModal: false }); }}
                            primaryMethod={() => { this.setState({ showPendingProcessMessageModal: false }); }}
                            btnTitle1={'OK'} >
                            <ul className="pending-process-messages-view-all-list">
                                {this.props.pendingProcessingMessages?.messages?.map((message: string, index: number) => (
                                    <li key={index}>{message}</li>
                                ))}
                            </ul>
                        </ModalMain>
                    </div>
                }

                {this.state.confirmDialogCancelSOVisible && <div className="errorModal"><ModalMain
                    modal={this.state.confirmDialogCancelSOVisible}
                    title="Cancel Sales Order"
                    hideMethod={() => { this.setState({ confirmDialogCancelSOVisible: false, pendingError: '' }); }}
                    primaryMethod={() => { this.setState({ confirmDialogCancelSOVisible: false, pendingError: '' }); }}
                    btnTitle1={'OK'} >
                    {ValidationMessages.General.Alert_Cancel_Page_Charge_Status}
                </ModalMain></div>}

                {this.state.confirmDialogUpdateVisible && hasChargeItemsForUpdate ? <ConfirmModal
                    title="Update Sales Order"
                    visible={this.state.confirmDialogUpdateVisible}
                    onConfirm={() => {
                        this.setState({ confirmDialogUpdateVisible: false, showDialog: false, pendingError: '' });
                        this.props.updateCharges(this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].id.toString(), 2, 8); this.setState({ wasSubmitted: true });
                    }}
                    closeModal={() => { this.setState({ confirmDialogUpdateVisible: false }); }}>
                    {ValidationMessages.General.Alert_Update_Page}
                </ConfirmModal> :
                    <div className="errorModal"><ModalMain
                        modal={this.state.confirmDialogUpdateVisible}
                        title="Error Message"
                        hideMethod={() => { this.setState({ confirmDialogUpdateVisible: false, pendingError: '' }); }}
                        primaryMethod={() => { this.setState({ confirmDialogUpdateVisible: false, pendingError: '' }); }}
                        btnTitle1={'OK'} >
                        {this.useReceivingSalesOrderValidation()
                            ? `${ValidationMessages.General.Alert_If_No_Charges_For_Sales_Order} ${this.getCurrentSalesOrderNumber()}.`
                            : ValidationMessages.General.Alert_If_No_Charges}
                    </ModalMain></div>}

                {this.state.confirmDialogResendVisible && <ConfirmModal
                    title="Resend latest message"
                    visible={this.state.confirmDialogResendVisible}
                    onConfirm={() => {
                        this.setState({ confirmDialogResendVisible: false, showDialog: false, pendingError: '' });
                        this.props.resendLatestMessage(this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].id.toString(), this.props.salesOrderResponseData.data[this.state.currentSalesOrderIndex].finOpsStatus);
                    }}
                    closeModal={() => { this.setState({ confirmDialogResendVisible: false }); }}>
                    {ValidationMessages.General.Alert_Resend_Page}
                </ConfirmModal>}
                <HeaderWrapper
                    firstValueLabel={'Primary Document Status'}
                    firstValue={this.props.exportJobDetails.originalDocumentNumber ?
                        <><a onClick={() => { this.props.history.push(`${documentLink}${this.props.exportJobDetails.primaryDocumentId}`); }}><b>{this.props.exportJobDetails.originalDocumentNumber}</b></a>-
                            {this.props.exportJobDetails.opsStatus}</> : <><b>Not Assigned</b></>}
                    secondValue={this.props.exportJobDetails.finOpsStatus}
                    forthValue={formatDate(this.props.exportJobDetails.lastUpdateDate)}
                    fifthValue={this.props.exportJobDetails.prepaidCollectIndicator}
                    statusColor={this.state.hasError ? 'red' : ''}
                    target={1}
                    totals={{
                        firstRow: { label: 'Total Revenue', value: this.state.totalRevenue, actualValue: this.state.actualRevenue },
                        secondRow: { label: 'Total Cost', value: this.state.totalCost, actualValue: this.state.actualCost },
                        lastRow: { label: 'Profitability' },
                        isNftpRoeEnabled: this.state.isNftpRoeEnabled,
                        breakdown: this.getProfitabilityBreakdown()
                    }}
                />
                <DetailsTopBar
                    number={this.props.exportJobDetails.documentNumber}
                    incoTerm={this.props.exportJobDetails.incoTerm}
                    shipmentType={this.props.exportJobDetails.shipmentType}
                    originService={this.props.exportJobDetails.serviceAtOrigin}
                    destinationService={this.props.exportJobDetails.serviceAtDestination}
                    etd={this.props.exportJobDetails.etd}
                    portOfDischargeCode={this.props.exportJobDetails.portOfDischargeCode}
                    placeOfReceiptCode={this.props.exportJobDetails.placeOfReceiptCode}
                    portOfLoadingCode={this.props.exportJobDetails.portOfLoadingCode}
                    placeOfDeliveryCode={this.props.exportJobDetails.placeOfDeliveryCode}
                    soNumber={this.props.isNftpBillable ? '' : this.props.exportJobDetails.salesOrderNumber}
                    isActionHidden={true}
                />
                <div className="padding-left-large padding-right-large exportjob-tabs">
                    <TabComponent name="exportJobs" navLinks={exportJobNavLinks}
                        callbackFc={(e: number) => this.setState({ activeTab: e - 1 })}
                        isDisabled={this.state.disableTab}
                        activeTab={this.state.activeTab} >
                        {this.renderTabChildren(isExtraDocumentFeatureEnabled, enableBlockedType)}
                    </TabComponent>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    exportJobDetails: state.exportJob.exportJobDetails,
    isLoading: state.exportJob.isFetchDataLoading,
    isFetchDataError: state.exportJob.isFetchDataError,
    detailsPendingError: state.exportJob.detailsPendingError,
    materialMasterList: state.materialMaster.materialMasterList,
    update: state.costRevenue.update,
    isCostAndRevenueLoadingError: state.costRevenue.isFetchDataError,
    invoicedResponse: state.invoices.invoicedResponse,
    submitInvoiceError: state.invoices.submitInvoicedError,
    resendResponse: state.sap.resendResponse,
    resendLoading: state.sap.isResendFetchDataLoading,
    resendError: state.sap.resendPendingError,
    isResendError: state.sap.isResendFetchDataError,
    featureToggles: state.featureToggle.featureToggles,
    costAndRevenueSplits: state.exportJob.exportDetailsCostAndRevenue,
    isCostAndRevenueLoading: state.exportJob.isExportDetailsCostAndRevenueLoading,
    costAndrevenueresponse: state.costRevenue.response,
    salesOrderResponseData: state.exportJob.salesOrderResponse,
    exportDetailsCbl: state.exportJob.exportDetailsCbl,
    nickname: state.nickname.userNickName,
    pendingProcessingMessages: state.costRevenue.pendingProcessingMessages,
    nftpBillableResponse: state.exportJob.nftpBillableResponse,
    isNftpBillable: state.exportJob.nftpBillableResponse?.isNftpBillable,
    isNftpBillableLoading: state.exportJob.isNftpBillableLoading
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchExportJobDetails: (exportJobId: number) => dispatch(fetchExportJobDetails(exportJobId)),
    fetchExportJobChargesDetails: (exportJobId: number) => dispatch(fetchExportJobChargesDetails(exportJobId)),
    updateCharges: (docId: string, docStage: number, rateAction: number) => dispatch(updateCharges(Number(docId), docStage, rateAction)),
    refreshAthenaRates: (refId: number, docId: number, docStage: number, rateAction: number) => dispatch(refreshAthenaRates(Number(refId), Number(docId), docStage, rateAction)),
    resendLatestMessage: (docId: string, finOpsStatus: string) => dispatch(resendLatestMessage(docId, 'EXPORTSALESORDER', finOpsStatus)),
    resetExportJobsDetails: () => dispatch(resetExportJobsDetails()),
    fetchCostAndRevenue: (type: number, valueId: any, targetType: string) => dispatch(fetchCostAndRevenue(type, valueId, targetType)),
    fetchSalesOrderData: (id: number, page?: number, pageSize?: number) => dispatch(fetchSalesOrderData(id, page, pageSize)),
    fetchExportJobCblDetails: (exportJobId: number) => dispatch(fetchExportJobCblDetails(exportJobId)),
    createSalesOrderExport: (refId: number, docStage: number, rateAction: number, category: 'ESSO', userId: string) => dispatch(sendCreateSalesOrderExport(refId, docStage, rateAction, category, userId)),
    getPendingProcessMessage: (targetId: number, targetType: 'Export' | 'Import') => dispatch(fetchPendingProcessMessages(targetId, targetType)),
    fetchNftpBillable: (jobId: number) => dispatch(fetchNftpBillable(jobId)),
});

export const _ExportJobs = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ExportJobDetails);
export const ExportJobs = withRouter(_ExportJobs);